import React from 'react'
import { URLS } from '../../../constants'
import { string } from 'prop-types'
import { Router } from '@reach/router'
import LazyComponent from '../../../components/LazyComponent/LazyComponent'
import { UpgradePlanoProvider } from '../../../contexts/UpgradePlanoContext'
import { RenovacaoPlanoProvider } from '../../../contexts/RenovacaoPlanoContext'
import { ReativacaoAssinaturaProvider } from '../../../contexts/ReativacaoAssinaturaContext'
import { SegundaAssinaturaProvider } from '../../../contexts/SegundaAssinaturaContext'
import { MODALIDADE } from '../constants'
import PaginaNaoEncontrada from '../../../containers/PaginaNaoEncontrada/PaginaNaoEncontrada'

import Plano from './Plano'
import Upgrade from './Upgrade/UpgradePlano'
import RenovacaoPlano from './RenovacaoPlano/RenovacaoPlano'
import ReativacaoAssinatura from './ReativacaoAssinatura/ReativacaoAssinatura'
import SegundaAssinatura from './SegundaAssinatura/SegundaAssinatura'
import CancelarAssinatura from './CancelarAssinatura/CancelarAssinatura'

export default function Rotas( { modalidadeDaRota } ) {
  const routePlano = modalidadeDaRota === MODALIDADE.CURADORIA ? URLS.CURADORIA_PLANO : URLS.INEDITOS_PLANO

  return (
    <Router>
      <PaginaNaoEncontrada default />
      <LazyComponent
        Component={ Plano }
        currentRoute={ routePlano }
        path="/"
      />
      <LazyComponent
        Component={ Upgrade }
        Context={ UpgradePlanoProvider }
        currentRoute={ routePlano }
        path="/upgrade/*"
      />
      <LazyComponent
        Component={ RenovacaoPlano }
        Context={ RenovacaoPlanoProvider }
        currentRoute={ routePlano }
        path="/renovar-plano/*"
      />
      <LazyComponent
        Component={ ReativacaoAssinatura }
        Context={ ReativacaoAssinaturaProvider }
        currentRoute={ routePlano }
        path="/reativar-assinatura/*"
      />
      <LazyComponent
        Component={ SegundaAssinatura }
        Context={ SegundaAssinaturaProvider }
        currentRoute={ routePlano }
        path="/segunda-assinatura/*"
      />
      <LazyComponent
        Component={ CancelarAssinatura }
        currentRoute={ routePlano }
        path="/cancelar-assinatura/*"
      />
    </Router>
  )
}

Rotas.propTypes = {
  'modalidadeDaRota': string.isRequired
}
